import React, { useEffect, useState } from 'react';
import "./ClinicsSelector.scss"

import Dropdown from '../../UI/Dropdown/Dropdown';

import { useSelector, useDispatch } from 'react-redux';
import { useFetching } from '../../../hooks/useFetching';
import PostService from '../../../API/PostService';
import { setClinicsAction } from '../../../store/clinicsReducer';
import { setClinicAction, setRecordsAction } from '../../../store/recordsTableReducer';

import Cookies from 'universal-cookie';

const ClinicsSelector = () => {
	const dispatch = useDispatch();
	const clinics = useSelector(state => state.clinics.clinics)
	const period = useSelector(state => state.recordsTable.period)
	const [clinicsList, setClinicsList] = useState(null)
	const [defaultClinic, setDefaultClinic] = useState(null)
	const cookies = new Cookies(null, { path: '/' });
	const defaultClinicCookie = cookies.get('default-clinic')

	useEffect(() => {
		if (!clinics || clinics?.length === 0) {
			fetchClinics();
		} else {
			setClinicsList(clinics);
			if (defaultClinicCookie) {
				const defaultClinicItem = clinics.find((el) => Number(el.id) === Number(defaultClinicCookie))
				if (defaultClinicItem) {
					setDefaultClinic(defaultClinicItem);
					dispatch(setClinicAction(defaultClinicItem.id));
					if (period) fetchRecords(defaultClinicItem.id, period)
				}
			} else {
				setDefaultClinic(clinics[0]);
				dispatch(setClinicAction(clinics[0].id));
				if (period) fetchRecords(clinics[0].id, period)
			}
		}
	}, [clinics])


	const [fetchRecords] = useFetching(async (clinic, period) => {
		const response = await PostService.getRecordsByPeriod(clinic, period)
		if (response.data.success && response.data.result !== false) {
			dispatch(setRecordsAction(response.data.result))
		}
	})

	const [fetchClinics] = useFetching(async () => {
		const response = await PostService.getClinics()
		if (response.data.success && response.data.result !== false) {
			dispatch(setClinicsAction(response.data.result))
		}
	})

	const selectedHandler = (id) => {
		const cookies = new Cookies(null, { path: '/' });
		cookies.set('default-clinic', id);
		dispatch(setClinicAction(id))

		if (period) fetchRecords(id, period)
	}

	return (
		<>
			{clinicsList &&
				<div className="clinics-selector">
					<Dropdown
						optionsList={clinicsList}
						optionSelected={defaultClinic}
						type='location'
						selectedHandler={selectedHandler} />
				</div>
			}
		</>
	);
};

export default ClinicsSelector;
